import { useEffect, useMemo, useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { DataGrid, type GridColDef, type GridSelectionModel } from '@mui/x-data-grid';

import useUserCourses from 'Hooks/useUserCourses';

const columns: GridColDef[] = [
  { field: 'id', headerName: '', width: 90, hide: true, flex: 1 },
  { field: 'name', headerName: 'Nombre', flex: 1 },
];

interface CourseAssignModalProps {
  userId: string;
  visible?: boolean;
  onClose?: () => void;
  onAssign?: (courseIds: string[]) => void;
}

const CourseAssignModal = ({ userId, visible = false, onClose, onAssign }: CourseAssignModalProps) => {
  const [selectedCourseIds, setSelectedCourseIds] = useState<GridSelectionModel>([]);

  const { courses, fetch } = useUserCourses({
    init: true,
    userId,
    assigned: false,
  });

  useEffect(() => {
    fetch(userId);
  }, [visible, fetch, userId]);

  const rows = useMemo(() => {
    if (!courses) return [];
    return courses.map(course => ({
      id: course.Course.id,
      name: course.Course.name,
      description: course.Course.description,
    }));
  }, [courses]);

  const handleAssign = () => {
    if (onAssign) {
      onAssign(selectedCourseIds as string[]);
    }
    handleClose();
  };

  const handleClose = () => {
    setSelectedCourseIds([]);
    fetch(userId);
    onClose?.();
  };

  return (
    <Dialog open={visible} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>Asignar cursos</DialogTitle>
      <DialogContent sx={{ height: '60vh', display: 'flex', flexDirection: 'column' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          checkboxSelection
          hideFooterPagination
          selectionModel={selectedCourseIds}
          onSelectionModelChange={(newSelection: GridSelectionModel) => setSelectedCourseIds(newSelection)}
        />
      </DialogContent>
      <DialogActions sx={{ padding: '1.5rem' }}>
        <Button onClick={handleClose} color="primary" variant="outlined">
          Cancelar
        </Button>
        <Button variant="contained" onClick={handleAssign} disabled={selectedCourseIds.length === 0} color="success">
          Asignar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CourseAssignModal;
